import { Component, OnInit, Input } from '@angular/core';
import { _MSGTYPES } from '../../../constant/msgType';
import { REPORT } from '../../../constant/report';
import { _HttpClient } from '@delon/theme';
import { DialogService } from '../../../services/dialog.service';
import { URLS } from '../../../constant/interface';
import { Location } from '@angular/common';
import { MsgPluginFilterService } from '../../../services/msg-plugin-filter.service';

@Component({
  selector: 'icc-report',
  templateUrl: './icc-report.component.html',
  styleUrls: ['./icc-report.component.less'],
})
export class IccReportComponent implements OnInit {
  constructor(private msgPluginFilterService: MsgPluginFilterService, public http: _HttpClient, private dialogService: DialogService, private location: Location) {}

  // 报表模块的id常量
  reportConstant: any;
  // 排行
  ranking = {
    NO_CHANGE: 0,
    ASC: 1,
    DESC: 2,
  };

  //?? [hidden]="-1 === matchedReportIds.indexOf(reportConstant.TREND_SEND.id)"
  matchedReportIds = [];

  // 需要显示的组件模块的id 列表
  @Input() reportIds: Array<number>;
  @Input() reportType: number;
  @Input() startDate: string;
  @Input() endDate: string;
  @Input() type: number;

  /* 将reportIds分成三部分是为了报表中的一些分割线和header更好的显示和控制 */
  // 发送数据总览，id是1-4的模块
  viewIds: Array<number>;
  totalIds: Array<number>;
  allViewIds: Array<number>;
  // 短信送数据统计，id是5-7的模块
  smsViewIds: Array<number>;
  // 微信送数据统计，id是8,9的模块
  wechatViewIds: Array<number>;
  // 其他消息类型发送数据统计，id为9以上的模块
  otherViewIds: Array<number>;

  // 月报的月份
  month: number;
  // 显示报表
  showContent: boolean;

  reportMode1: any;
  reportMode2 = {
    dateList: [],
    receiveList: [],
    sendList: [],
    ratioList: [],
  };
  reportMode3: Array<{
    msgType: number; // 消息类型
    count: number; // 发送量
    ratio: number; // 发送占比
    ranking: number; // 排名浮动：0为不变 1为上升 2为下降
  }>;
  reportMode4: Array<any>;
  reportMode5 = {
    dateList: [],
    receiveList: [],
    sendList: [],
    ratioList: [],
  };
  reportMode6: Array<any>;
  reportMode7: any;
  reportMode10 = {
    dateList: [],
    receiveList: [],
    sendList: [],
    ratioList: [],
  };
  reportMode11: any;
  reportMode12 = {
    AllTalkTime: 0,
    dayTalkTime: 0,
    list: [],
  };
  reportMode8: Array<any>;
  reportMode9: Array<any>;
  reportMode13: any;

  clear() {
    this.showContent = false;
    this.reportMode1 = {};
    this.reportMode2 = {
      dateList: [],
      receiveList: [],
      sendList: [],
      ratioList: [],
    };
    this.reportMode3 = [];
    this.reportMode4 = [];
    this.reportMode5 = {
      dateList: [],
      receiveList: [],
      sendList: [],
      ratioList: [],
    };
    this.reportMode6 = [];
    this.reportMode7 = {};
    this.reportMode10 = {
      dateList: [],
      receiveList: [],
      sendList: [],
      ratioList: [],
    };
    this.reportMode8 = [];
    this.reportMode9 = [];
    this.reportMode13 = {};
    this.reportMode11 = {};
    this.reportMode12 = {
      AllTalkTime: 0,
      dayTalkTime: 0,
      list: [],
    };
  }

  loadReportData() {
    this.clear();
    this.requestReportData().then(
      (data: Array<any>) => {
        this.clear();
        this.showContent = true;
        data.forEach(modeItem => {
          let modeData: any;
          switch (modeItem.modeId) {
            case REPORT.TOTAL_SEND.id:
              // 总发送量
              this.reportMode1 = modeItem.reportDataList[0];
              break;
            case REPORT.TREND_SEND.id:
              // 发送趋势图
              modeData = modeItem.reportDataList;
              if (modeItem.reportDataList instanceof Array) {
                modeItem.reportDataList.forEach(item => {
                  this.reportMode2.dateList.push(item.date.slice(4, 6) + '.' + item.date.slice(6));
                  this.reportMode2.receiveList.push(+item.receive);
                  this.reportMode2.sendList.push(+item.send);
                  this.reportMode2.ratioList.push(+item.ratio);
                });
              }
              break;
            case REPORT.RATIO_MSG_SEND.id:
              // 各消息类型发送占比
              modeData = modeItem.reportDataList;
              if (modeData && modeData[0] && modeData[0].list instanceof Array) {
                modeData[0].list.forEach(item => {
                  this.reportMode3.push({
                    msgType: item.msgType,
                    count: item.count,
                    ratio: +item.ratio,
                    ranking: this.ranking[item.ranking],
                  });
                });
              }
              break;
            case REPORT.TOTAL_BIZTYPE_SEND.id:
              // 业务类型发送量top5
              this.reportMode4 = modeItem.reportDataList;
              if (this.reportMode4 instanceof Array) {
                modeItem.reportDataList.forEach(item => {
                  item.ratio = +item.ratio;
                  item.ranking = this.ranking[item.ranking];
                });
              }
              break;
            case REPORT.TREND_SMS_SEND.id:
              // 短信发送趋势
              modeData = modeItem.reportDataList;
              if (modeItem.reportDataList instanceof Array) {
                modeItem.reportDataList.forEach(item => {
                  this.reportMode5.dateList.push(item.date.slice(4, 6) + '.' + item.date.slice(6));
                  this.reportMode5.receiveList.push(+item.receive);
                  this.reportMode5.sendList.push(+item.send);
                  this.reportMode5.ratioList.push(+item.ratio);
                });
              }
              break;
            case REPORT.RATIO_SMS_CHANNEL.id:
              // 短信渠道发送占比
              modeData = modeItem.reportDataList;
              if (modeItem.reportDataList instanceof Array) {
                const tempArr = [];
                modeItem.reportDataList.forEach(item => {
                  tempArr.push({
                    channelName: item.channelName,
                    count: item.count,
                    ratio: +item.ratio,
                    success: +item.success,
                  });
                });
                this.reportMode6 = tempArr;
              }
              break;
            case REPORT.TOTAL_MO_SMS.id:
              // 短信上行统计
              modeData = modeItem.reportDataList;
              if (modeData && modeData[0] && modeData[0].list instanceof Array) {
                modeData[0].list.forEach(item => {
                  this.reportMode7 = {
                    count: +item.count,
                    users: +item.users,
                    unsubscribe: +item.unsubscribe,
                    keywords: +item.keywords,
                    others: +item.others,
                  };
                });
              }
              break;
            case REPORT.TOTAL_WECHAT_FANS.id:
              // 微信粉丝
              this.setWechatFans(modeItem.reportDataList);
              break;
            case REPORT.TREND_WECHAT_INDICATOR.id:
              // 微信关键指标趋势
              this.setWechatIndicator(modeItem.reportDataList);
              break;
            case REPORT.TREND_EMAIL_SEND.id:
              // 邮件发送趋势
              modeData = modeItem.reportDataList;
              if (modeItem.reportDataList instanceof Array) {
                modeItem.reportDataList.forEach(item => {
                  this.reportMode10.dateList.push(item.date.slice(4, 6) + '.' + item.date.slice(6));
                  this.reportMode10.receiveList.push(+item.receive);
                  this.reportMode10.sendList.push(+item.send);
                  this.reportMode10.ratioList.push(+item.ratio);
                });
              }
              break;
            case REPORT.TOTAL_MO_EMAIL.id:
              // 邮件上行统计
              modeData = modeItem.reportDataList;
              if (modeData && modeData[0]) {
                this.reportMode11 = {
                  count: +modeData[0].count,
                  users: +modeData[0].users,
                  unsubscribe: +modeData[0].unsubscribe,
                  keywords: +modeData[0].keywords,
                  others: +modeData[0].others,
                };
              } else {
                this.reportMode11 = {
                  count: 0,
                  users: 0,
                  unsubscribe: 0,
                  keywords: 0,
                  others: 0,
                };
              }
              break;
            case REPORT.TREND_VOICE_TIME.id:
              // 语音通话时长趋势图
              modeData = modeItem.reportDataList;
              if (modeData && modeData[0] && modeData[0].list instanceof Array) {
                this.reportMode12.AllTalkTime = +modeData[0].totalTalkTime;
                this.reportMode12.dayTalkTime = +modeData[0].dayTalkTime;
                modeData[0].list.forEach(item => {
                  this.reportMode12.list.push({
                    date: item.date.slice(4, 6) + '.' + item.date.slice(6),
                    dayTalkTime: +item.dayTalkTime,
                    averTalkTime: +item.averTalkTime,
                  });
                });
              }

              break;
            case REPORT.FUNNEL_VOICE_SEND.id:
              // 语音消息发送漏斗图
              modeData = modeItem.reportDataList;
              if (modeData instanceof Array) {
                modeData.forEach(item => {
                  this.reportMode13 = item;
                });
              }
              break;
            default:
              break;
          }
        });
        if (this.reportIds.indexOf(this.reportConstant.TOTAL_WECHAT_FANS.id) || this.reportIds.indexOf(this.reportConstant.TREND_WECHAT_INDICATOR.id)) {
        }
      },
      err => {},
    );
  }
  /*
   * 设置微信粉丝
   */
  setWechatFans(modeData) {
    const emptyObj = {
      officialAccount: {
        icon: '',
        name: '',
      },
      fans: {
        follow: 0,
        new: 0,
        unfollow: 0,
        compare: {
          follow: 0,
          new: 0,
          unfollow: 0,
        },
      },
    };
    if (modeData instanceof Array) {
      modeData.forEach((item, index) => {
        const tempItem = {
          officialAccount: {
            icon: item.officialAccount.icon || '',
            name: item.officialAccount.name || '',
          },
          fans: {
            follow: item.fans.follow,
            new: item.fans.newfollow,
            unfollow: item.fans.unfollow,
            compare: {
              follow: +item.fans.compare.followRatio,
              new: +item.fans.compare.newfollowRatio,
              unfollow: +item.fans.compare.unfollowRatio,
            },
          },
        };
        this.reportMode8.push(tempItem);
      });
    }
  }

  setWechatIndicator(modeData) {
    const emptyObj = {
      officialAccount: {
        icon: '',
        name: '',
      },
      indicator: [],
    };
    if (modeData instanceof Array) {
      modeData.forEach((item, index) => {
        const tempItem = {
          officialAccount: {
            icon: item.officialAccount.icon || '',
            name: item.officialAccount.name || '',
          },
          indicator: item.list || [],
        };
        tempItem.indicator.forEach(_listItem => {
          _listItem.date = _listItem.date.slice(4, 6) + '.' + _listItem.date.slice(6);
          _listItem.pageView = +_listItem.pageView; // 阅读次数
          _listItem.share = +_listItem.share; // 分享次数
          _listItem.transpond = +_listItem.transpond; // 转发次数
        });
        this.reportMode9.push(tempItem);
      });
    }
  }

  getTwoPartIds(ids) {
    const result = {
      viewIds: [],
      totalIds: [],
    };
    if (ids instanceof Array) {
      ids.forEach(id => {
        if (id <= this.reportConstant.TOTAL_BIZTYPE_SEND.id) {
          result.viewIds.push(id);
        } else {
          result.totalIds.push(id);
        }
      });
    }
    return result;
  }

  ngOnInit() {
    // 1、获取report id的常量对象
    this.reportConstant = REPORT;
    
    /* 前端消息类型插件配置 */
    this.msgPluginFilterService.getReportIdsByPlugin(rIds => {
      let temp = [1];
      this.reportIds.forEach(handId => {
        for(let i = 0, len = rIds.length; i < len; i++) {
          if(handId === rIds[i]) {
            temp.push(handId);
            break;
          }
        }
      })
      this.reportIds = temp;
      const id_result = this.getTwoPartIds(this.reportIds);
      this.viewIds = id_result.viewIds;
      this.totalIds = id_result.totalIds;
      if (this.reportType === 1) {
        // this.month = new Date(this.startDate).getMonth() + 1;
        this.month = Number(this.startDate.split('.')[1]);
      }
      this.loadReportData();
    })
  }

  /* 邮件发送趋势-数据模拟 */
  getEmailTrend() {
    const result = {
      reportType: 1,
      dateList: [],
      receiveList: [],
      sendList: [],
      ratioList: [],
    };
    for (let i = 1; i < 32; i++) {
      const str = i < 10 ? '0' + i : i;
      result.dateList.push('05.' + str);
      let reciveRandom = Math.random() * 10000000;
      result.receiveList.push(Math.floor(reciveRandom));
      result.sendList.push(Math.floor(Math.random() * reciveRandom));
      result.ratioList.push(Math.floor(Math.random() * 100));
    }
    return result;
  }

  /* 语音通话时长趋势-数据模拟 */
  getVoiceTrend() {
    const result = {
      reportType: 0,
      AllTalkTime: 3021, // 本周/月总通话时长
      dayTalkTime: 431, // 日均通话时长
      list: [],
    };
    const len = result.reportType ? 31 : 7;
    for (let i = 1; i < len + 1; i++) {
      const str = i < 10 ? '0' + i : i;
      result.list.push({
        date: '05.' + str,
        dayTalkTime: Math.floor(Math.random() * 100), // 日均通话时长
        averTalkTime: Math.floor(Math.random() * 10), // 平均通话时长
      });
    }
    return result;
  }

  // 数据请求
  requestReportData() {
    return new Promise((resolve, reject) => {
      console.log(this.startDate.replace(/\./g, '-'));
      this.http
        .post(URLS.getPreviewData.url, {
          type: this.reportType,
          modeIds: this.reportIds,
          startTime: this.startDate.replace(/\./g, '-') + ' 00:00:00',
          endTime: this.endDate.replace(/\./g, '-') + ' 00:00:00',
        })
        .subscribe(
          (res: any) => {
            if (res.status === 0 && res.data instanceof Array) {
              resolve(res.data);
            } else {
              this.dialogService.notification.error('请求失败', res.errorMsg);
            }
          },
          error => {
            reject(error);
          },
        );
    });
  }

  // 返回顶部
  onBack() {
    this.location.back();
  }

  // 更新锚点
}
